import {Component} from '@angular/core';
import { ToastController } from '@ionic/angular';
import { Dialog, DialogsService } from 'app/dialogs';
import { UserProfile, UserRole } from 'app/profile/model/model';
import { UserService } from 'app/profile/services/user.service';

import {NavService} from 'shared/nav/nav.service';
import { DefaultMenuPage } from '../default-menu-page/default-menu-page';
import { TranslateService } from '@ngx-translate/core';

const DEV_ROLE_TITLE: string = 'APP_ADMIN';

@Component({
  selector: 'menu-page',
  templateUrl: 'menu-page.html',
  styleUrls: ['menu-page.scss'],
})
export class MenuPage extends DefaultMenuPage {

  public devOptionsEnabled: boolean = false;

  public devOptionsAllowed: boolean = false;

  public hasContents: boolean = false;

  public newDialogsCount: number = 0;

  private _dialogs: Array<Dialog>;
  
  constructor(
    public navService: NavService,
    private toastController: ToastController,
    private userService: UserService,
    private dialogsService: DialogsService,
    private translateService: TranslateService,
  ) {
    super(navService, translateService);
    this.userService.getUserProfile('full').subscribe(this.onProfileLoaded.bind(this));
  }

  public ngOnInit(): void {
    this.dialogsService.getDialogs()
      .subscribe((dialogs) => {
        this._dialogs = dialogs.filter(dia => dia.thesis === undefined);
        this.newDialogsCount = this._dialogs.length;
      });
  }

  private ionViewWillEnter(): void {
    this.devOptionsEnabled = this.userService.getAdminMode()
  }

  public get newBadgeCount(): number {
    return this.userService.getNewBadgeCount();
  }

  public get newContentCount(): number {
    return this.userService.getNewContentCount();
  }

  public showDevOptions(): void {
    this.navService.push('profile/devoptions');
  }

  public showPage(page:string, evt: PointerEvent): void {
    // console.log(evt);
    // console.log(evt.pageY);
    // console.log(evt.clientY+ " " + evt.target['clientHeight']);
    let dy = evt['layerY'];
    let obj = evt.target;
    let cnt = 0;
    while ( cnt < 10 && obj['nodeName'] != "ION-ITEM" ) {
      cnt++;
      obj = obj['parentNode'];
    }
    let y = evt.pageY-dy+obj['clientHeight'];
    console.log("== "+y);
    this.navService.push('menu/' + page, {lineY: y}); // minus clientY oder so
  }

  public async devMode(): Promise<void> {
    if ( this.devOptionsAllowed ) {
      this.userService.setAdminMode(true);
      this.devOptionsEnabled = true;
      const toast: HTMLIonToastElement = await this.toastController.create({
        message: 'TestModus',
        position: 'bottom',
        duration: 2000,
      });
      await toast.present();

    }
  }

  private onProfileLoaded(profile: UserProfile): void {
    const devRole: UserRole = profile.roles.find((role) => {return role.name === DEV_ROLE_TITLE; });
    if (devRole) {
      this.devOptionsAllowed = true;
    }
    this.hasContents = profile.contents && profile.contents.some((userContent) => userContent.state === 0 || userContent.state >= 5);
  }
}
